import PropTypes from 'prop-types';

RInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  containerClassNames: PropTypes.string,
  inputClassNames: PropTypes.string,
  register: PropTypes.func,
};

export function RInput({
  id,
  name,
  type = 'text',
  containerClassNames,
  inputClassNames,
  placeholder,
  register,
  ...restInputProps
}) {
  return (
    <div className={`input-container ${containerClassNames}`}>
      <input
        id={id}
        name={name}
        type={type}
        className={`input-field ${inputClassNames}`}
        placeholder={placeholder}
        {...restInputProps}
        {...register(name)}
      />

      <span className="icon-success">
        <i className="fas fa-check txt-c-green" />
      </span>
    </div>
  );
}
